import React, { useState } from 'react';
import { Check, X, ArrowRight, Layers, Clock, BarChart3, Users, Shield, Briefcase, RefreshCw } from 'lucide-react';
import { motion } from 'framer-motion';
import { CampaignSelector } from '../components/CampaignSelector';
const fmt = (n: number) => n.toLocaleString('en-US');
export function SummitProduct() {
  const [campaignMode, setCampaignMode] = useState(1);
  const isPartial = campaignMode === 0;
  const campaigns = isPartial ? 1 : campaignMode;
  const buildFee = 6500 + Math.max(0, campaignMode - 1) * 500;
  const systemFee = 2500;
  const campaignFee = 1250 * (campaignMode + 1);
  const corpRecruiter = 1250 * (campaignMode + 1);
  const monthlyTotal = systemFee + campaignFee + corpRecruiter;
  return <div className="min-h-screen w-full bg-[#0A0F1C] text-slate-200 selection:bg-amber-500/30 font-sans" data-id="element-1122" data-mp="33gqpemxd1bqy">
      {/* 1. HERO */}
      <section className="relative pt-32 pb-8 px-6 md:px-12 max-w-7xl mx-auto text-center" data-id="element-1123" data-mp="2ue7nc51ef35r">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-96 bg-amber-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-1124" data-mp="2uglisezzqhdu" />

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-1125" data-mp="n8v020sfq3rx">
          <div className="inline-block px-3 py-1 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-xs font-bold uppercase tracking-widest mb-6" data-id="element-1126" data-mp="dfx9d7dah8i8">
            Embedded Execution
          </div>
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 tracking-tight" data-id="element-1127" data-mp="s6wf8amqpiy4">
            HIRE Summit
          </h1>
          <p className="text-xl md:text-2xl text-slate-400 max-w-3xl mx-auto leading-relaxed" data-id="element-1128" data-mp="w7q5vbrkhbup">
            Summit is designed for teams who want recruiting execution handled
            so leadership can stay focused on production and growth.
          </p>
        </motion.div>
      </section>

      {/* 2. PRICING */}
      <section className="pt-4 pb-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-1129" data-mp="1neoqa0jsiw6a">
        <CampaignSelector mode={campaignMode} onChange={setCampaignMode} accent="amber" data-id="element-1130" data-mp="1igdhlt58erpn" />

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-1131" data-mp="1dovmhlpw3lcl">
          {/* Build Fee */}
          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl relative overflow-hidden" data-id="element-1132" data-mp="18qc0jlbaq9k8">
            <div className="mb-4" data-id="element-1133" data-mp="14r394n3qanru">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-1134" data-mp="zqf776dyomiu">
                Build and Implementation (One-Time)
              </div>
              <div className="text-3xl font-bold text-white" data-id="element-1135" data-mp="us40v5mvku5d">
                ${fmt(buildFee)}
              </div>
              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-1136" data-mp="pu2d47ei86nk">
                {['Company and opportunity profiling', 'Custom ATS with dashboards, workflows, and job board integrations', 'Culture video and ad copywriting', 'Landing pages and candidate application flows', 'Full funnel design, from ad to onboarding', 'Compensation and role benchmarking by region', 'Pre-launch system stress test', 'Team training and 90-day coaching to optimize output', 'Ten Sales School tickets'].map((point, i) => <li key={i} className="flex items-start" data-id="element-1137" data-mp="29qhyii8eyg6z" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-amber-400 mr-2 mt-0.5 shrink-0" data-id="element-1138" data-mp="2dr1uvjl5xfs2" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-1139" data-mp="2iotwj5bm0g9g">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          {/* Monthly Total */}
          <div className="bg-slate-900/40 border border-amber-500/30 p-6 rounded-xl relative" data-id="element-1140" data-mp="3u6cykudged6f">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500 rounded-t-xl" data-id="element-1141" data-mp="301zv4vx1oi9" />
            <div className="mb-4" data-id="element-1142" data-mp="1bv5vj51fas29">
              <div className="text-xs text-amber-400 uppercase tracking-widest mb-2" data-id="element-1143" data-mp="16w2qvlpcunut">
                Total Monthly
              </div>
              <div className="text-4xl font-bold text-white mb-1" data-id="element-1144" data-mp="1kwdhqoqo02fz">
                ${fmt(monthlyTotal)}
              </div>
              <div className="text-sm text-slate-500 mb-6" data-id="element-1145" data-mp="1fv69ypoiv39b">/ month</div>

              <div className="space-y-3 pt-4 border-t border-slate-800/50" data-id="element-1146" data-mp="1usgueoj57jh6">
                <div className="flex justify-between text-sm" data-id="element-1147" data-mp="1pv6tabme5jdi">
                  <span className="text-slate-400" data-id="element-1148" data-mp="1psug0brkvx6s">Catalyst ATS</span>
                  <span className="text-white font-medium" data-id="element-1149" data-mp="23lk5iq6bfk8n">
                    ${fmt(systemFee)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-1150" data-mp="2dk9e1scbnsc8">
                  <span className="text-slate-400" data-id="element-1151" data-mp="2dkj1b85zfle8">Campaign Management</span>
                  <span className="text-white font-medium" data-id="element-1152" data-mp="28mhjsro7fu4v">
                    ${fmt(campaignFee)}
                  </span>
                </div>
                <div className="flex justify-between text-sm" data-id="element-1153" data-mp="2s53vcnmosri8">
                  <span className="text-slate-400" data-id="element-1154" data-mp="2x5jbto29mf4f">Corporate Recruiter</span>
                  <span className="text-white font-medium" data-id="element-1155" data-mp="2i7qx2y4jlura">
                    ${fmt(corpRecruiter)}
                  </span>
                </div>
              </div>

              <ul className="mt-5 space-y-2.5 pt-4 border-t border-slate-800/50" data-id="element-1156" data-mp="29gqmiag5f5is">
                {['Active ad management and real-time optimization', 'Live applicant screening, 14 hrs/day, 7 days/week', 'Second-round interview execution handled by a US-based corporate recruiter representing YOUR brand', 'Monthly recruiting review and ongoing consulting'].map((point, i) => <li key={i} className="flex items-start" data-id="element-1157" data-mp="1qjpeegraspam" data-mpi={i}>
                    <Check className="w-3.5 h-3.5 text-amber-400 mr-2 mt-0.5 shrink-0" data-id="element-1158" data-mp="1ui4z2dzwplkv" />
                    <span className="text-slate-400 text-sm leading-snug" data-id="element-1159" data-mp="10qtp8jy700g">
                      {point}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-1160" data-mp="3ngldf9i0nv05">
            <div className="mb-4" data-id="element-1161" data-mp="3ii0av3fakz8j">
              <div className="text-xs text-amber-400 uppercase tracking-widest mb-4" data-id="element-1162" data-mp="3iew0tpf5b99y">
                Sales School Tickets
              </div>
              <div className="flex items-baseline mb-2" data-id="element-1163" data-mp="ezqn0tieo32y">
                <span className="text-3xl font-bold text-white" data-id="element-1164" data-mp="ey5okssyzzzt">$125</span>
                <span className="text-slate-400 ml-2 text-sm" data-id="element-1165" data-mp="9zknys9t3eau">per ticket</span>
              </div>
              <p className="mt-5 pt-4 border-t border-slate-800/50 text-slate-400 text-sm leading-snug" data-id="element-1166" data-mp="5z0rzs0yygqa">
                Sales School tickets are purchased separately based on the number
                of attendees, up to a $5,000 monthly maximum.
              </p>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-amber-500/5 border border-amber-500/20 rounded-lg max-w-3xl mx-auto" data-id="element-1167" data-mp="169lblod2l8bf">
          <p className="text-amber-400 text-center font-medium" data-id="element-1168" data-mp="1a79bz6xj7tap">
            Ad spend is paid directly to the job platforms and is separate from
            HIRE's fees.
          </p>
        </div>
      </section>

      {/* 2. THE EXECUTION BOTTLENECK */}
      <section className="py-20 px-6 md:px-12 max-w-4xl mx-auto border-t border-slate-800/50" data-id="element-1169" data-mp="1oz1hysbfruzr">
        <div className="text-center mb-12" data-id="element-1170" data-mp="1twjpce9t225n">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-1171" data-mp="1tzfog5xe2wvo">
            The Execution Bottleneck
          </h2>
          <p className="text-slate-400 text-lg" data-id="element-1172" data-mp="1xx3p7plrjjvh">
            At scale, recruiting doesn't fail because of traffic or systems.
          </p>
        </div>

        <div className="bg-slate-900/30 border border-slate-800 p-8 md:p-12 rounded-xl" data-id="element-1173" data-mp="3m70sju9uoui">
          <h3 className="text-sm text-amber-400 uppercase tracking-widest font-bold mb-6 text-center" data-id="element-1174" data-mp="8l1ifigi67d1">
            Execution Constraints
          </h3>
          <ul className="space-y-4 max-w-2xl mx-auto" data-id="element-1175" data-mp="2af616g80pp5x">
            {['Leaders are pulled into interviews', 'Follow-up slows down', 'Calendars bottleneck', 'Recruiting becomes a second job'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-1176" data-mp="2fabw24jeee65" data-mpi={idx}>
                <X className="w-5 h-5 text-amber-500/50 mr-3 mt-0.5 flex-shrink-0" data-id="element-1177" data-mp="1rjfwgl8paeoc" />
                <span data-id="element-1178" data-mp="1ni4ft57t13sa">{item}</span>
              </li>)}
          </ul>
          <p className="text-center text-slate-400 mt-8 pt-8 border-t border-slate-800" data-id="element-1179" data-mp="21hdkb7mne9gf">
            Summit exists to remove that bottleneck.
          </p>
        </div>
      </section>

      {/* 3. WHAT CHANGES WITH SUMMIT */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-1180" data-mp="3cupq3o1yx258">
        <div className="max-w-5xl mx-auto" data-id="element-1181" data-mp="37vuzhzxre9ak">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1182" data-mp="37zafd4z9bmd1">
            What Changes With Summit
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-1183" data-mp="ynzvj1quk7wj">
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-1184" data-mp="ylvle22cucnt">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-1185" data-mp="kqjqnuo78m6w">
                <Shield className="w-6 h-6 text-amber-400" data-id="element-1186" data-mp="1dde9kn5dbdi9" />
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-1187" data-mp="1dfiaqxbvtyeu">Execution Ownership</h3>
              <p className="text-slate-400 text-sm" data-id="element-1188" data-mp="1hdy3lhuna106">
                Recruiting execution becomes HIRE's responsibility
              </p>
            </div>
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-1189" data-mp="18lmfw3qx0rnw">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-1190" data-mp="1wca11qpuddse">
                <Users className="w-6 h-6 text-amber-400" data-id="element-1191" data-mp="213s0298b14aq" />
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-1192" data-mp="vcqkxfsoy5s3">Managed Throughput</h3>
              <p className="text-slate-400 text-sm" data-id="element-1193" data-mp="10cbpq6ujl8cq">
                Interview throughput is managed, not improvised
              </p>
            </div>
            <div className="bg-slate-900/40 border border-slate-800 p-6 rounded-xl" data-id="element-1194" data-mp="mc0u6qiaf5l8">
              <div className="w-12 h-12 rounded-full bg-slate-800 flex items-center justify-center mb-4 border border-slate-700" data-id="element-1195" data-mp="qd46x451gli8">
                <Briefcase className="w-6 h-6 text-amber-400" data-id="element-1196" data-mp="cko3414bcjg9" />
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-1197" data-mp="hf20g92jd0nk">Protected Time</h3>
              <p className="text-slate-400 text-sm" data-id="element-1198" data-mp="2pmed6dy9je7">
                Leadership time is protected for production and growth
              </p>
            </div>
          </div>

          <div className="p-6 bg-amber-500/5 border border-amber-500/20 rounded-lg max-w-3xl mx-auto" data-id="element-1199" data-mp="3ptj3z3hmemoa">
            <p className="text-amber-400 font-medium text-center" data-id="element-1200" data-mp="3usvohhl0rhnp">
              Summit does not change the recruiting system — it changes who runs
              it.
            </p>
          </div>
        </div>
      </section>

      {/* 4. OWNERSHIP MAP */}
      <section className="py-20 px-6 md:px-12 max-w-6xl mx-auto" data-id="element-1201" data-mp="369lkcvintve0">
        <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1202" data-mp="3k8bkkk0s0b6l">
          Ownership Map
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-16" data-id="element-1203" data-mp="3g43q067n010g">
          {/* HIRE Owns */}
          <div className="bg-slate-900/40 border border-amber-500/20 rounded-xl p-8 relative overflow-hidden" data-id="element-1204" data-mp="3u3vcywg4srql">
            <div className="absolute top-0 left-0 w-full h-1 bg-amber-500" data-id="element-1205" data-mp="3p63a57dy7l7m" />
            <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-1206" data-mp="7ok2lntndctb">
              <span className="w-2 h-2 rounded-full bg-amber-500 mr-3" data-id="element-1207" data-mp="2qilh8fs7nkh" />
              HIRE Owns
            </h3>
            <ul className="space-y-4" data-id="element-1208" data-mp="grbetpuckcm0">
              {['Dedicated recruiter capacity (operated and managed by HIRE)', 'Interview execution and scheduling', 'Candidate follow-up and throughput', 'Recruiting execution accountability'].map((item, idx) => <li key={idx} className="flex items-start text-slate-300" data-id="element-1209" data-mp="3ag5eiqntbn6t" data-mpi={idx}>
                  <Check className="w-5 h-5 text-amber-500 mr-3 mt-0.5 flex-shrink-0" data-id="element-1210" data-mp="3eijtv0s9w4tc" />
                  <span data-id="element-1211" data-mp="3jbmsvoftk6gx">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* You Own */}
          <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 relative overflow-hidden" data-id="element-1212" data-mp="3oc0uanmx0i5z">
            <div className="absolute top-0 left-0 w-full h-1 bg-slate-600" data-id="element-1213" data-mp="3tau342r9bkzt" />
            <h3 className="text-xl font-bold text-white mb-8 flex items-center" data-id="element-1214" data-mp="23hkdjaq6zhs">
              <span className="w-2 h-2 rounded-full bg-slate-600 mr-3" data-id="element-1215" data-mp="63rrx0e61xyr" />
              You Own
            </h3>
            <ul className="space-y-4" data-id="element-1216" data-mp="23vw32kl3g7z9">
              {['Final hiring approvals', 'Sales leadership and production', 'Culture and performance expectations'].map((item, idx) => <li key={idx} className="flex items-start text-slate-400" data-id="element-1217" data-mp="1vlowvqtk2ckv" data-mpi={idx}>
                  <div className="w-5 h-5 rounded-full bg-slate-800 border border-slate-700 mr-3 mt-0.5 flex-shrink-0 flex items-center justify-center" data-id="element-1218" data-mp="1vjlxwhafd940">
                    <div className="w-1.5 h-1.5 rounded-full bg-slate-500" data-id="element-1219" data-mp="1mm1x19gh5etx" />
                  </div>
                  <span data-id="element-1220" data-mp="2j9q3gu76bixn">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-8 text-center" data-id="element-1221" data-mp="2ecpwmh2i2c5h">
          <p className="text-slate-400 font-medium" data-id="element-1222" data-mp="2aa3228eg2d4l">
            Summit transfers execution ownership and staffing risk to HIRE.
          </p>
        </div>
      </section>

      {/* 5. RECRUITER CAPACITY */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-1223" data-mp="yvphpdiwgftb">
        <div className="max-w-4xl mx-auto" data-id="element-1224" data-mp="twctopgal2p5">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1225" data-mp="tui8rb50tal2">
            Recruiter Capacity
          </h2>

          <div className="bg-slate-900/40 border border-slate-800 rounded-xl p-8 md:p-12" data-id="element-1226" data-mp="2hqohi7sja1xx">
            <div className="space-y-6" data-id="element-1227" data-mp="2mksqsxp9um26">
              <div className="flex items-start" data-id="element-1228" data-mp="28smk0280drfe">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-1229" data-mp="28txmzztmqv5g">
                  <Check className="w-5 h-5 text-amber-400" data-id="element-1230" data-mp="30jinic86ijq0" />
                </div>
                <div data-id="element-1231" data-mp="35idcjvwqp4ik">
                  <h3 className="text-white font-bold mb-2" data-id="element-1232" data-mp="35ivhri1dqt2m">
                    Trained and Managed by HIRE
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1233" data-mp="2ri2losvfjpxe">
                    Recruiters are trained, managed, and quality-controlled by
                    HIRE to maintain consistency and professionalism.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1234" data-mp="1l31q4oabh9rc">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-1235" data-mp="1l0fgmj3v8k6h">
                  <Check className="w-5 h-5 text-amber-400" data-id="element-1236" data-mp="18kfv2dmoea1a" />
                </div>
                <div data-id="element-1237" data-mp="1mjfhdempucua">
                  <h3 className="text-white font-bold mb-2" data-id="element-1238" data-mp="1mjxml0rcw1ec">
                    Represents Your Brand
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1239" data-mp="1hl47x50c24cl">
                    Recruiters represent the client's brand with professionalism
                    and alignment to company values.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-1240" data-mp="13kjpwb28sck5">
                <div className="w-10 h-10 rounded-full bg-slate-800 flex items-center justify-center mr-4 flex-shrink-0 border border-slate-700" data-id="element-1241" data-mp="13mecrux2qeqv">
                  <Check className="w-5 h-5 text-amber-400" data-id="element-1242" data-mp="b48z88a6x0d0" />
                </div>
                <div data-id="element-1243" data-mp="65fje97fkx9o">
                  <h3 className="text-white font-bold mb-2" data-id="element-1244" data-mp="65xq5zrpytvu">
                    Designed for Consistency
                  </h3>
                  <p className="text-slate-400 text-sm" data-id="element-1245" data-mp="266vxjqwy3up9">
                    Capacity is designed to support consistent interview flow,
                    not heroic bursts.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 7. WHO SUMMIT IS FOR / NOT FOR */}
      <section className="py-20 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800" data-id="element-1246" data-mp="2k0wpa0phchg4">
        <div className="max-w-5xl mx-auto" data-id="element-1247" data-mp="1nb5sfutpui75">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-1248" data-mp="1s74cx7bxbg2a">
            Who Summit Is For
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-1249" data-mp="1w8ps4zbxk6fn">
            <div data-id="element-1250" data-mp="2193uq1urio6a">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-1251" data-mp="219n958l7eufk">
                <Check className="w-5 h-5 text-amber-500 mr-2" data-id="element-1252" data-mp="37pfv89l24i51" />
                Summit is a fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-1253" data-mp="3cmfykcqiv6sg">
                {['Want recruiting execution off your plate', 'Believe sales leaders should be selling, not interviewing', 'Prefer external ownership over internal hiring', 'Trust HIRE to manage recruiter performance'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-1254" data-mp="3912rwufyyfpp" data-mpi={idx}>
                    <span className="w-1.5 h-1.5 rounded-full bg-amber-500 mr-3 mt-2" data-id="element-1255" data-mp="340wv6zuue30r" />
                    {item}
                  </li>)}
              </ul>
            </div>
            <div data-id="element-1256" data-mp="2u30meepdnk5t">
              <h3 className="text-lg font-bold text-white mb-6 flex items-center" data-id="element-1257" data-mp="2u2h1qq8ceho3">
                <X className="w-5 h-5 text-slate-500 mr-2" data-id="element-1258" data-mp="2q1f3ocq5wbnp" />
                Summit is not a fit if you:
              </h3>
              <ul className="space-y-4" data-id="element-1259" data-mp="sbxa7kzu9xj5">
                {['Want to manage recruiters internally', 'Prefer hands-on control over execution', 'Only want infrastructure or consulting'].map((item, idx) => <li key={idx} className="text-slate-400 flex items-start" data-id="element-1260" data-mp="1bk5kr1sytcii" data-mpi={idx}>
                    <span className="w-1.5 h-1.5 rounded-full bg-slate-600 mr-3 mt-2" data-id="element-1261" data-mp="1bm881e2qgrjj" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* 8. HOW THIS SCALES */}
      <section className="py-16 px-6 md:px-12 bg-slate-900/20 border-y border-slate-800 text-center" data-id="element-1262" data-mp="nu1d8jcnosm8">
        <div className="max-w-3xl mx-auto" data-id="element-1263" data-mp="svh2yops3nay">
          <h2 className="text-2xl font-bold text-white mb-8" data-id="element-1264" data-mp="eu4pql205zsr">
            How This Scales
          </h2>
          <div className="flex flex-col md:flex-row justify-center gap-6 text-left" data-id="element-1265" data-mp="jsy044lztaop">
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-1266" data-mp="2985vlpvyzn2c">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-1267" data-mp="296bc8g0ck30d">
                Foundation
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-1268" data-mp="2oae1t8ug4i88">Advantage</h3>
              <p className="text-slate-400 text-sm" data-id="element-1269" data-mp="2jc2scz82c9qj">
                Where most teams start before scaling execution.
              </p>
            </div>
            <div className="flex-1 p-6 border border-amber-500/30 rounded-lg bg-slate-800/30" data-id="element-1270" data-mp="2x4akuesbdejf">
              <div className="text-xs text-amber-400 uppercase tracking-widest mb-2" data-id="element-1271" data-mp="2sbzasj3v0cd5">
                Execution
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-1272" data-mp="373ro6pk3fgc8">Summit</h3>
              <p className="text-slate-400 text-sm" data-id="element-1273" data-mp="321sk1dgj4fe8">
                Recruiting execution handled for you.
              </p>
            </div>
            <div className="flex-1 p-6 border border-slate-800 rounded-lg bg-slate-900/40" data-id="element-1274" data-mp="3g00os7jt4kzy">
              <div className="text-xs text-slate-500 uppercase tracking-widest mb-2" data-id="element-1275" data-mp="3byxa3odhwv0b">
                Leadership
              </div>
              <h3 className="text-white font-bold mb-2" data-id="element-1276" data-mp="1hn8q37seq292">Leadership</h3>
              <p className="text-slate-400 text-sm" data-id="element-1277" data-mp="1hp3ewx6sueif">
                Add it when finding leadership becomes the bottleneck.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 9. CTA */}
      <section className="py-32 px-6 md:px-12 text-center border-t border-slate-800/50" data-id="element-1278" data-mp="yr3dsg5skbrg">
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-8" data-id="element-1279" data-mp="trqta22e7gs1">
          See if Summit is the right execution model for your team.
        </h2>
        <button className="inline-flex items-center px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white font-bold rounded-lg transition-all" data-id="element-1280" data-mp="62fxkyzwgckr">
          Discuss Summit
          <ArrowRight className="ml-2 w-5 h-5" data-id="element-1281" data-mp="f2uku3wfc1qw" />
        </button>
      </section>
    </div>;
}